/**
 * Register
 */
export const Register = (function () {

  var init =  function () { 

    // Add event listeners for validation
    $('#inputPassword').change(function () {
      validatePassword();
    });
    $('#inputPassword').click(function () {
      document.getElementById("message").classList.add("d-none");
    });
    $("#inputPassword").keypress(function () {
      document.getElementById("message").classList.add("d-none");
    });
    $('#confirm_password').change(function () {
      validatePassword();
    });
    $('#confirm_password').change(function () {
      document.getElementById("message").classList.add("d-none");
    });
    $('#confirm_password').change(function () {
      document.getElementById("message").classList.add("d-none");
    });
    $('#mydexid').click(function () {
      document.getElementById("message").classList.add("d-none");
    });
    $("#mydexid").keypress(function () {
      document.getElementById("message").classList.add("d-none");
    });
    $('#inputEmail').click(function () {
      document.getElementById("message").classList.add("d-none");
    });
    $("#inputEmail").keypress(function () {
      document.getElementById("message").classList.add("d-none");
    });

    $("#create_form").submit(function (event) {

      event.preventDefault(); //prevent default action 
  
      var post_url = "/register"; //get form action url
      var request_method = $(this).attr("method"); //get form GET/POST method
      var form_data = $(this).serialize(); //Encode form elements for submission
  
      $.ajax({
        url: post_url,
        type: request_method,
        data: form_data
  
  
      }).done(function (response) { //
        
        if (response.Success == true) {
          document.location = response.URL;
        }
        else {
  
          var text;

          switch (response.URL.error.message) {
            case "Mydexid already in use.":
              text = "This MydexID is already in use. Please try another.";
  
              document.getElementById("mydexid").focus();
              $("#mydexid").val('');
  
  
              break;
            case "Email already in use.":
              text = response.URL.error.message + ' Please try another.';
              document.getElementById("inputEmail").focus();
              $("#inputEmail").val('');
              break;
  
            default:
              text = response.URL.error.message;
          }
          $("#password").val('');
  
          document.getElementById("message").classList.remove("d-none");
          document.getElementById("error-message").innerHTML = text;
        }
  
  
      });
    });
     
  }
  function validatePassword() {

    var password = document.getElementById("inputPassword")
    var confirm_password = document.getElementById("confirm_password");

    if (password.value != confirm_password.value) {
      confirm_password.setCustomValidity("Passwords Don't Match");
    } else {
      confirm_password.setCustomValidity('');
    }
  }

  return {
    init: init,
    validatePassword : validatePassword
  }

}());


